import { UPDATE_PERFORM_AUDIT_LAYERS } from '../../constants/appTypes';

import { IPerformAuditCriteriaData } from '../../types/auditdata';

const initialState: Array<IPerformAuditCriteriaData> = [];

interface performAuditLayersAction {
  performAuditLayers: Array<IPerformAuditCriteriaData>;
  type: string;
}

export function performAuditLayers(state = initialState, action: performAuditLayersAction) {
  switch (action.type) {
    case UPDATE_PERFORM_AUDIT_LAYERS:
      state = action.performAuditLayers;
      return state;
    default:
      return state;
  }
}

export default performAuditLayers;
